__turbopack_context__.v({
  "canvas": "LayerView-module-scss-module__TtS2oW__canvas",
  "canvasEventSurface": "LayerView-module-scss-module__TtS2oW__canvasEventSurface",
  "canvasWrap": "LayerView-module-scss-module__TtS2oW__canvasWrap",
  "focusTag": "LayerView-module-scss-module__TtS2oW__focusTag",
  "sidebar": "LayerView-module-scss-module__TtS2oW__sidebar",
  "view": "LayerView-module-scss-module__TtS2oW__view",
});
